import api from "../api";

const endpoint = "/api/perfis";
const obterTodos = async () => {
  return new Promise((resolve, reject) => {
    return api
      .get(endpoint)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default {
  obterTodos,
};
